import * as React from 'react';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_CHART } from '@editor/src/img/pageIndex';
import i18n from '@i18next/i18n';
import { PresetChartType } from '@src/slide/domain/ui-model/element-modeles/chart-models/chart-presets/const';
import type { MenuConfig } from '@tencent/workbench';

export const config = {
    id: ActionType.INSERT_CHART,
    icon: TOOLBAR_CHART,
    content: i18n.t('柱状图'),
};

// 簇状柱状图
export const COLUMN_CLUSTERED_CHART_CONFIG = {
    id: `${config.id}-col-cluster`,
    content: i18n.t('簇状柱状图'),
};
// 堆积柱状图
export const COLUMN_STACKED_CHART_CONFIG = {
    id: `${config.id}-col-stacked`,
    content: i18n.t('堆积柱状图'),
};
// 百分比堆积柱状图
export const COLUMN_PERCENT_STACKED_CHART_CONFIG = {
    id: `${config.id}-col-percent-stacked`,
    content: i18n.t('百分比堆积柱状图'),
};
// 簇状条形图
export const BAR_CLUSTERED_CHART_CONFIG = {
    id: `${config.id}-bar-cluster`,
    content: i18n.t('簇状条形图'),
};
// 堆积条形图
export const BAR_STACKED_CHART_CONFIG = {
    id: `${config.id}-bar-stacked`,
    content: i18n.t('堆积条形图'),
};
// 百分比堆积条形图
export const BAR_PERCENT_STACKED_CHART_CONFIG = {
    id: `${config.id}-bar-percent-stacked`,
    content: i18n.t('百分比堆积条形图'),
};
// 普通折线图
export const LINE_STANDARD_CHART_CONFIG = {
    id: `${config.id}-line-standard`,
    content: i18n.t('折线图'),
};
// 堆积折线图
export const LINE_STACKED_CHART_CONFIG = {
    id: `${config.id}-line-stacked`,
    content: i18n.t('堆积折线图'),
};
// 百分比堆积折线图
export const LINE_PERCENT_STACKED_CHART_CONFIG = {
    id: `${config.id}-line-percent-stacked`,
    content: i18n.t('百分比堆积折线图'),
};
// 带数据标记的普通折线图
export const LINE_STANDARD_CHART_WITH_POINT_CONFIG = {
    id: `${config.id}-line-standard-with-point`,
    content: i18n.t('带数据标记的折线图'),
};
// 带数据标记的堆积折线图
export const LINE_STACKED_CHART_WITH_POINT_CONFIG = {
    id: `${config.id}-line-stacked-with-point`,
    content: i18n.t('带数据标记的堆积折线图'),
};
// 带数据标记的百分比堆积折线图
export const LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG = {
    id: `${config.id}-line-percent-stacked-with-point`,
    content: i18n.t('带数据标记的百分比堆积折线图'),
};
// 饼图
export const PIE_CHART_CONFIG = {
    id: `${config.id}-pie-standard`,
    content: i18n.t('饼图'),
};
// 子母饼图
export const OF_PIE_CHART_CONFIG = {
    id: `${config.id}-of-pie`,
    content: i18n.t('子母饼图'),
};
// 复合饼图
export const OF_PIE_BAR_CHART_CONFIG = {
    id: `${config.id}-of-pie-bar`,
    content: i18n.t('复合饼图'),
};
// 圆环图
export const DOUGHNUT_CHART_CONFIG = {
    id: `${config.id}-doughnut`,
    content: i18n.t('圆环图'),
};
// 面积图
export const AREA_CHART_CONFIG = {
    id: `${config.id}-area-standard`,
    content: i18n.t('面积图'),
};
// 堆积面积图
export const AREA_STACKED_CHART_CONFIG = {
    id: `${config.id}-stacked-area`,
    content: i18n.t('堆积面积图'),
};
// 百分比堆积面积图
export const AREA_PERCENT_STACKED_CHART_CONFIG = {
    id: `${config.id}-percent-stacked-area`,
    content: i18n.t('百分比堆积面积图'),
};
// 雷达图
export const RADAR_CHART_CONFIG = {
    id: `${config.id}-radar-standard`,
    content: i18n.t('雷达图'),
};
// 带数据标记的雷达图
export const RADAR_WITH_POINT_CHART_CONFIG = {
    id: `${config.id}-radar-with-point`,
    content: i18n.t('带数据标记的雷达图'),
};
// 填充雷达图
export const RADAR_WITH_FILL_CHART_CONFIG = {
    id: `${config.id}-radar-filled`,
    content: i18n.t('填充雷达图'),
};
export const insertChartTypeMap: Record<string, PresetChartType> = {
    [COLUMN_CLUSTERED_CHART_CONFIG.id]: PresetChartType.COLUMN_CLUSTERED,
    [COLUMN_STACKED_CHART_CONFIG.id]: PresetChartType.COLUMN_STACKED,
    [COLUMN_PERCENT_STACKED_CHART_CONFIG.id]: PresetChartType.COLUMN_PERCENT_STACKED,

    [BAR_CLUSTERED_CHART_CONFIG.id]: PresetChartType.BAR_CLUSTERED,
    [BAR_STACKED_CHART_CONFIG.id]: PresetChartType.BAR_STACKED,
    [BAR_PERCENT_STACKED_CHART_CONFIG.id]: PresetChartType.BAR_PERCENT_STACKED,

    [LINE_STANDARD_CHART_CONFIG.id]: PresetChartType.LINE_STANDARD,
    [LINE_STACKED_CHART_CONFIG.id]: PresetChartType.LINE_STACKED,
    [LINE_PERCENT_STACKED_CHART_CONFIG.id]: PresetChartType.LINE_PERCENT_STACKED,
    [LINE_STANDARD_CHART_WITH_POINT_CONFIG.id]: PresetChartType.LINE_STANDARD_WITH_POINT,
    [LINE_STACKED_CHART_WITH_POINT_CONFIG.id]: PresetChartType.LINE_STACKED_WITH_POINT,
    [LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG.id]: PresetChartType.LINE_PERCENT_STACKED_WITH_POINT,

    [PIE_CHART_CONFIG.id]: PresetChartType.PIE,
    [OF_PIE_CHART_CONFIG.id]: PresetChartType.OF_PIE,
    [OF_PIE_BAR_CHART_CONFIG.id]: PresetChartType.OF_PIE_BAR,
    [DOUGHNUT_CHART_CONFIG.id]: PresetChartType.DOUGHNUT,

    [AREA_CHART_CONFIG.id]: PresetChartType.AREA,
    [AREA_STACKED_CHART_CONFIG.id]: PresetChartType.AREA_STACKED,
    [AREA_PERCENT_STACKED_CHART_CONFIG.id]: PresetChartType.AREA_PERCENT_STACKED,

    [RADAR_CHART_CONFIG.id]: PresetChartType.RADAR,
    [RADAR_WITH_FILL_CHART_CONFIG.id]: PresetChartType.RADAR_WITH_FILL,
    [RADAR_WITH_POINT_CHART_CONFIG.id]: PresetChartType.RADAR_WITH_POINT,

};

export const INSERT_CHART_CONFIGS: MenuConfig[] = [
    {
        name: `${config.id}-col`,
        content: i18n.t('柱状图') as string,
    },
    {
        name: `${config.id}-line`,
        content: i18n.t('折线图') as string,
    },
    {
        name: `${config.id}-bar`,
        content: i18n.t('条形图') as string,
    },
    {
        name: `${config.id}-pie`,
        content: i18n.t('饼图') as string,
    },
    {
        name: `${config.id}-area`,
        content: i18n.t('面积图') as string,
    },
    {
        name: `${config.id}-radar`,
        content: i18n.t('雷达图') as string,
    },
    ...[
        COLUMN_CLUSTERED_CHART_CONFIG,
        COLUMN_STACKED_CHART_CONFIG,
        COLUMN_PERCENT_STACKED_CHART_CONFIG,
        BAR_CLUSTERED_CHART_CONFIG,
        BAR_STACKED_CHART_CONFIG,
        BAR_PERCENT_STACKED_CHART_CONFIG,
        LINE_STANDARD_CHART_CONFIG,
        LINE_STACKED_CHART_CONFIG,
        LINE_PERCENT_STACKED_CHART_CONFIG,
        LINE_STANDARD_CHART_WITH_POINT_CONFIG,
        LINE_STACKED_CHART_WITH_POINT_CONFIG,
        LINE_PERCENT_STACKED_CHART_WITH_POINT_CONFIG,
        PIE_CHART_CONFIG,
        OF_PIE_CHART_CONFIG,
        OF_PIE_BAR_CHART_CONFIG,
        DOUGHNUT_CHART_CONFIG,
        AREA_CHART_CONFIG,
        AREA_STACKED_CHART_CONFIG,
        AREA_PERCENT_STACKED_CHART_CONFIG,
        RADAR_CHART_CONFIG,
        RADAR_WITH_POINT_CHART_CONFIG,
        RADAR_WITH_FILL_CHART_CONFIG,
    ].map(conf => ({
        name: conf.id,
        content: conf.content,
    })),
];
